import { useEffect, useState } from "react";
import { fetchCostCenterGroups, downloadCostCenterGroupsExcel } from "../Api/ViewCostCenterGroup";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewCostCenterGroup = () => {
  const [costCenterGroups, setCostCenterGroups] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadCostCenterGroups = async () => {
      try {
        const data = await fetchCostCenterGroups();
        setCostCenterGroups(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Cost Center Groups`);
      }
    };

    loadCostCenterGroups();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadCostCenterGroupsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'CostCenterGroups_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Cost Center Groups data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="py-3">
          <Container fluid className="list-container">
            <div className="header-background">
              <h2 className="header-list-title">View Cost Center Groups</h2>
              <Button 
                className="gradient-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || costCenterGroups.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {costCenterGroups.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Group Code</th>
                    <th>Group Name</th>
                    <th>Cost Center Code</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {costCenterGroups.map((group, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{group.groupCode}</td>
                      <td>{group.groupName}</td>
                      <td>{group.costCenterCode}</td>
                      <td>
                        {moment(group.createdOnDate).format('L')} at {group.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{group.createdBy}</td>
                      <td>
                        {group.changedOnDate ? 
                          `${moment(group.changedOnDate).format('L')} at ${group.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{group.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No cost center groups found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewCostCenterGroup;